'use client'

import { MinimumThresholdDisplay } from '~/components/automations/MinimumThresholdDisplay'
import {
  AddressDisplay,
  Group,
  List,
  TokenDisplay,
} from '~/components/component-library'
import { ListItemProps } from '~/components/component-library/List/types'
import { SupportedChainId } from '~/constants/chains'
import { AutomationPolicy } from '~/types/automations'

export const AutomationPolicyDisplay = ({
  policy,
}: {
  policy: AutomationPolicy
}) => {
  const swapItems: ListItemProps[] = policy.outputs.map((output, index) => ({
    key: `swap-${index}-${output.targetTokenAddress}-${output.targetChainId}`,
    content: (
      <TokenDisplay
        address={output.targetTokenAddress}
        chainId={output.targetChainId as SupportedChainId}
        layout={'standard' as const}
      />
    ),
    meta: <span className="text-sm text-secondary">{output.percent}%</span>,
  }))

  const totalPercent = policy.outputs.reduce((sum, o) => sum + o.percent, 0)

  const passThroughFooter =
    totalPercent === 0
      ? undefined
      : totalPercent >= 100
        ? '100% allocated to token swaps'
        : `Remaining ${policy.passThroughPercent}% of the incoming token will be forwarded as-is to the deposit account`

  return (
    <>
      <Group label="Destination account" layout="horizontal">
        <AddressDisplay
          address={policy.passThroughDestinationAddress}
          layout="standard"
          isInternal
        />
      </Group>
      <List label="Token swaps" items={swapItems} footer={passThroughFooter} />
      <MinimumThresholdDisplay value={policy.minimumThresholdUsd} />
    </>
  )
}
